//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'HeadCircumferenceAndAgePercentileOfInfants',
  data () {
    return {
      form: {
        data1: '',
        data2: '',
        data3: ''
      },
      dataList1: [
        { name: '男', value: '0' },
        { name: '女', value: '1' }
      ],
      dataList2: [
        { name: '0月', value: '0' },
        { name: '1月', value: '1' },
        { name: '2月', value: '2' },
        { name: '3月', value: '3' },
        { name: '4月', value: '4' },
        { name: '5月', value: '5' },
        { name: '6月', value: '6' },
        { name: '7月', value: '7' },
        { name: '8月', value: '8' },
        { name: '9月', value: '9' },
        { name: '10月', value: '10' },
        { name: '11月', value: '11' },
        { name: '1岁', value: '12' },
        { name: '1岁1月', value: '13' },
        { name: '1岁2月', value: '14' },
        { name: '1岁3月', value: '15' },
        { name: '1岁4月', value: '16' },
        { name: '1岁5月', value: '17' },
        { name: '1岁6月', value: '18' },
        { name: '1岁7月', value: '19' },
        { name: '1岁8月', value: '20' },
        { name: '1岁9月', value: '21' },
        { name: '1岁10月', value: '22' },
        { name: '1岁11月', value: '23' },
        { name: '2岁', value: '24' },
        { name: '2岁3月', value: '25' },
        { name: '2岁6月', value: '26' },
        { name: '2岁9月', value: '27' },
        { name: '3岁', value: '28' }
      ],
      comparisontable0: [{'p3': 31.9, 'p25': 33.4, 'p75': 35.2, 'p97': 36.8},
        {'p3': 34.8, 'p25': 36.2, 'p75': 37.8, 'p97': 39.2},
        {'p3': 36.9, 'p25': 38.3, 'p75': 39.9, 'p97': 41.3},
        {'p3': 38.3, 'p25': 39.7, 'p75': 41.3, 'p97': 42.7},
        {'p3': 39.4, 'p25': 40.8, 'p75': 42.4, 'p97': 43.9},
        {'p3': 40.3, 'p25': 41.7, 'p75': 43.4, 'p97': 44.9},
        {'p3': 41.1, 'p25': 42.5, 'p75': 44.2, 'p97': 45.7},
        {'p3': 41.8, 'p25': 43.2, 'p75': 44.9, 'p97': 46.4},
        {'p3': 42.4, 'p25': 43.8, 'p75': 45.5, 'p97': 47},
        {'p3': 42.8, 'p25': 44.3, 'p75': 46.1, 'p97': 47.5},
        {'p3': 43.2, 'p25': 44.7, 'p75': 46.4, 'p97': 47.9},
        {'p3': 43.6, 'p25': 45, 'p75': 46.7, 'p97': 48.3},
        {'p3': 43.8, 'p25': 45.3, 'p75': 46.1, 'p97': 48.6},
        {'p3': 44.1, 'p25': 45.5, 'p75': 46.4, 'p97': 48.8},
        {'p3': 44.3, 'p25': 45.8, 'p75': 46.6, 'p97': 49},
        {'p3': 44.5, 'p25': 46, 'p75': 46.8, 'p97': 49.3},
        {'p3': 44.7, 'p25': 46.2, 'p75': 47, 'p97': 49.4},
        {'p3': 44.9, 'p25': 46.3, 'p75': 47.2, 'p97': 49.6},
        {'p3': 45.1, 'p25': 46.5, 'p75': 47.4, 'p97': 49.8},
        {'p3': 45.2, 'p25': 46.7, 'p75': 47.5, 'p97': 50},
        {'p3': 45.4, 'p25': 46.9, 'p75': 47.7, 'p97': 50.2},
        {'p3': 45.6, 'p25': 47, 'p75': 47.9, 'p97': 50.4},
        {'p3': 45.7, 'p25': 47.2, 'p75': 48.1, 'p97': 50.5},
        {'p3': 45.9, 'p25': 47.4, 'p75': 48.2, 'p97': 50.7},
        {'p3': 46, 'p25': 47.5, 'p75': 48.3, 'p97': 50.8},
        {'p3': 46.3, 'p25': 47.8, 'p75': 48.7, 'p97': 51.2},
        {'p3': 46.6, 'p25': 48.1, 'p75': 48.9, 'p97': 51.5},
        {'p3': 46.8, 'p25': 48.3, 'p75': 49.2, 'p97': 51.7},
        {'p3': 47, 'p25': 48.5, 'p75': 49.3, 'p97': 51.9}],
      comparisontable1: [
        {'p3': 31.5, 'p25': 33.1, 'p75': 34.8, 'p97': 36.3},
        {'p3': 34.2, 'p25': 35.6, 'p75': 37.1, 'p97': 38.5},
        {'p3': 36.2, 'p25': 37.5, 'p75': 39, 'p97': 40.3},
        {'p3': 37.5, 'p25': 38.8, 'p75': 40.3, 'p97': 41.6},
        {'p3': 38.5, 'p25': 39.8, 'p75': 41.4, 'p97': 42.7},
        {'p3': 39.3, 'p25': 40.7, 'p75': 42.3, 'p97': 43.7},
        {'p3': 40, 'p25': 41.4, 'p75': 43, 'p97': 44.5},
        {'p3': 40.7, 'p25': 42.1, 'p75': 43.7, 'p97': 45.2},
        {'p3': 41.2, 'p25': 42.7, 'p75': 44.3, 'p97': 45.8},
        {'p3': 41.7, 'p25': 43.2, 'p75': 44.8, 'p97': 46.3},
        {'p3': 42.1, 'p25': 43.6, 'p75': 45.2, 'p97': 46.8},
        {'p3': 42.5, 'p25': 44, 'p75': 45.6, 'p97': 47.1},
        {'p3': 42.8, 'p25': 44.3, 'p75': 45.9, 'p97': 47.5},
        {'p3': 43.1, 'p25': 44.5, 'p75': 46.2, 'p97': 47.8},
        {'p3': 43.3, 'p25': 44.8, 'p75': 46.5, 'p97': 48},
        {'p3': 43.5, 'p25': 45, 'p75': 46.9, 'p97': 48.3},
        {'p3': 43.7, 'p25': 45.2, 'p75': 47.1, 'p97': 48.5},
        {'p3': 43.9, 'p25': 45.4, 'p75': 47.3, 'p97': 48.7},
        {'p3': 44.1, 'p25': 45.6, 'p75': 47.6, 'p97': 48.8},
        {'p3': 44.2, 'p25': 45.7, 'p75': 47.8, 'p97': 49},
        {'p3': 44.4, 'p25': 45.9, 'p75': 48, 'p97': 49.2},
        {'p3': 44.6, 'p25': 46.1, 'p75': 48.2, 'p97': 49.4},
        {'p3': 44.7, 'p25': 46.2, 'p75': 48.4, 'p97': 49.5},
        {'p3': 44.8, 'p25': 46.3, 'p75': 48.5, 'p97': 49.7},
        {'p3': 45, 'p25': 46.5, 'p75': 48.7, 'p97': 49.8},
        {'p3': 45.3, 'p25': 46.8, 'p75': 48.9, 'p97': 50.2},
        {'p3': 45.5, 'p25': 47.1, 'p75': 49.1, 'p97': 50.5},
        {'p3': 45.8, 'p25': 47.3, 'p75': 49.3, 'p97': 50.8},
        {'p3': 46.1, 'p25': 47.6, 'p75': 49.6, 'p97': 51.1}
      ],
      descTxt: ''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      console.log(self.comparisontable0.length, 777)
      let form = JSON.parse(JSON.stringify(self.form))
      if (form.data3 > 70 || form.data3 < 10) return
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        return ''
      }
      let result = form.data3
      console.log(form, 666)
      const comparisontable = self['comparisontable' + form.data1][form.data2]
      console.log(comparisontable, 888)
      if (result <= comparisontable.p3) {
        self.descTxt = '评价等级:下(P3)'
      } else if (result >= comparisontable.p3 && result < comparisontable.p25) {
        self.descTxt = '评价等级:中下(P3-P25)'
      } else if (result >= comparisontable.p25 && result < comparisontable.p75) {
        self.descTxt = '评价等级:(P25-P75)'
      } else if (result >= comparisontable.p75 && result < comparisontable.p97) {
        self.descTxt = '评价等级:(P75-P97)'
      } else if (result >= comparisontable.p97) {
        self.descTxt = '评价等级:上(P97)'
      }

      return String(result)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/HeadCircumferenceAndAgePercentileOfInfants.vue